<ng-container
  *ngIf="{
    listing: listing$ | async
  } as observables">
  <ate-ui-header
    class="tw-w-full"
    [isMobile]="isMobile"
    [isLoadingCreditBalance]="isLoadingCreditBalance"
    [credits]="credits"
    [paymentsRoute]="paymentsRoute"
    [listing]="observables.listing"
    (logout)="logout()"></ate-ui-header>
</ng-container>
